import { render } from "./Dates.vue?vue&type=template&id=2fff1b5c"
import script from "./Dates.vue?vue&type=script&lang=js"
export * from "./Dates.vue?vue&type=script&lang=js"

import "./Dates.vue?vue&type=style&index=0&id=2fff1b5c&lang=scss"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__